import { ISellerPhoneSchema } from '../../repositories/newbuilding-card/entities/agents/SellerPhoneSchema';
import { IPhoneSchema } from '../../repositories/newbuilding-card/entities/phone/PhoneSchema';

export function getPhoneString(phone: null | undefined): null;
export function getPhoneString(phone: IPhoneSchema | ISellerPhoneSchema): string;
export function getPhoneString(phone: IPhoneSchema | ISellerPhoneSchema | null | undefined): string | null;

export function getPhoneString(phone: IPhoneSchema | ISellerPhoneSchema | null | undefined): string | null {
  return phone ? `${phone.countryCode}${phone.code}${phone.number}` : null;
}
